module.exports = __webpack_public_path__ + "img/match-desc.75b66cc3.png";